import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import "./styles/layout/MainLayout.scss";
import AppRoutes from "./routes/AppRoutes";

function App() {
  return (
    <Router>
      <div className="main-layout">
        <Sidebar />
        <div className="content">
          <Header />
          <main className="main-content">
            <AppRoutes />
          </main>
        </div>
      </div>
    </Router>
  );
}

export default App;
